/**
 * Toggle util to enable/disable page scrolling
 *
 * @param {boolean} isEnabled - if page body scrolling is enabled
 *
 * Notes:
 * Prevent the background content from scrolling when the modal is opened.
 * https://github.com/reactjs/react-modal/issues/191
 */
export const toggleBodyScrolling = isEnabled => {
  if (document && document.body) {
    document.body.style.overflow = isEnabled ? 'unset' : 'hidden';
  }
};
